import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=6c1b96b4&"
import script from "./Withdrawal.vue?vue&type=script&lang=js&"
export * from "./Withdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports